/* eslint-disable max-len, consistent-return */

// zrm-utils-js
import PathsManifest from '@zg-rentals/zrm-utils-js/lib/pathsManifest';

const getAllPaths = (brand) => {
    const pathsManifest = new PathsManifest('/rental-manager', brand);

    return pathsManifest.getAllPaths();
};

const makeAbsolute = (path, brand) => {
    const pathsManifest = new PathsManifest('/rental-manager', brand);

    return pathsManifest.getAbsolutePath(path);
};

const formatUrl = (url) => {
    return `/rental-manager/${url}`;
};

const RMW_PATH = {
    LISTING_CLAIMING: formatUrl('listing-claiming'),
    LISTING_CLAIMING_HELP: '/corp/Terms.htm', // @TODO fix once we know the url
};

export {
    RMW_PATH,
};

export default {
    getAllPaths,
    makeAbsolute,
};
